// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, isSupported } from 'firebase/messaging'
import { axiosInstance } from '../network/adapter'
import { ApiEndPoints } from '../network/endpoints'
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: 'AIzaSyAE5SKIna9DvLEI9pBYa_RHjIMWJZ19Xks',
  authDomain: 'oujat-8e701.firebaseapp.com',
  projectId: 'oujat-8e701',
  storageBucket: 'oujat-8e701.firebasestorage.app',
  messagingSenderId: '385510799605',
  appId: '1:385510799605:web:41173b1388737aff6a6dbc',
  measurementId: 'G-90ZYZH3YLW'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const messaging = getMessaging(app)
// const analytics = getAnalytics(app);

// export const getNotificationPermission = async (setTokenFound) => {
//   await Notification.requestPermission().then((permission) => {
//     console.log("permission", permission);
//     if(permission === "denied"){
//       setTokenFound(false);
//     }
//     else{
//       setTokenFound(true);
//     }
//   });
// };
// Import the functions you need from the SDKs you need

export const getNotificationPermission = async setFcmToken => {
  try {
    const supported = await isSupported()
    if (!supported || typeof window === 'undefined') {
      return
    }
    if (!('Notification' in window) || !('serviceWorker' in navigator)) {
      return
    }

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') {
      setFcmToken('')
      return
    }

    let registration = await navigator.serviceWorker.getRegistration('/firebase-messaging-sw.js')
    if (!registration) {
      registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')
    }

    const token = await getToken(messaging, {
      vapidKey: 'BNGaXwstR1NvupJ90XbfG445YsKN1JOfbGI19nk7OGpKD8dHfvwFA_S8_9TyECcBm4bbjvkgj9HQMOBlHkm-yzA',
      serviceWorkerRegistration: registration
    })
    if (token) {
      setFcmToken(token)
    }
  } catch (error) {
    console.warn('FCM registration failed:', error)
    setFcmToken('')
  }
}
